import "./styles.scss";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import ImageLightbox from "components/ImageLightbox";

import { useTask } from "context/client/task";

import ModalNew from "components/ModalNew";
import TextEditor, { convertToHTML, getPlainText } from "components/TextEditor";

const mainClass = "client-comments-modal";

const ClientCommentsModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const { sendMessage, file_progress, updateTask } = useTask();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [content, setContent] = useState(null);
  const [files, setFiles] = useState([]);
  const [lightbox, setLightbox] = useState(null);

  const handleSubmit = async () => {
    setIsSubmitting(true);

    try {
      await sendMessage(convertToHTML(content), files);
      await updateTask({ status: 2 });

      setTimeout(() => {
        onClose();
        setContent(null);
        setFiles([]);
      }, 200);
    } catch (err) {
      console.log(err);
    }

    setIsSubmitting(false);
  };

  const html = convertToHTML(content);
  const plainText = getPlainText(html);
  const isEmpty = plainText === "";
  const isUploading = file_progress !== undefined && file_progress !== null;

  return (
    <>
      <ModalNew
        title={t("Request a correction")}
        variant="wide"
        loading={isSubmitting}
        hasMobileScrollTop={false}
        isOpen={isOpen}
        isSubmitHidden
        onClose={onClose}
        onSubmit={handleSubmit}
      >
        <div className={mainClass}>
          <TextEditor
            id="task_correction"
            content={content}
            setContent={setContent}
            files={files}
            setFiles={setFiles}
            isDisabled={isSubmitting || isUploading}
            isSubmitDisabled={isEmpty && !(files.length > 0)}
            onPreviewClick={(url) => setLightbox(url)}
            onSubmit={handleSubmit}
          />
        </div>
      </ModalNew>

      {!!lightbox && (
        <ImageLightbox
          src={lightbox}
          onClose={() => setLightbox(null)}
        />
      )}
    </>
  );
};

export default ClientCommentsModal;
